import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";

function RecruitMain({ getLink }) {
  const [scrollPosition, setScrollPosition] = useState(0);
  
  useEffect(() => {
    getLink(window.location.href);
    window.addEventListener("scroll", updateScroll);
  }, [getLink]);

  // 스크롤 pc
  const updateScroll = () => {
    setScrollPosition(window.scrollY || document.documentElement.scrollTop);
  };


  const pc = useMediaQuery({
    query: "(min-width : 1024px)",
  });

  return (
    <>
      {pc ? (
        <>
          <div className={ scrollPosition > 499 ? "basic-banner recruit-banner on" : "basic-banner recruit-banner"}>
            <div className="basic-banner-title">
              <p className="txt">배려와 공감속에서 창의와 자율을 통해</p>
              <p className="txt">동반 성장하는 문화를 가진 기업</p>
            </div>
          </div>
          <div className="inner">
          <div className="recurit-growth">
            <ul className="recruit-growth-item">
              <li className="recruit-growth-list">
                <h2 className="basic-title">헬리오센은</h2>
                <h3 className="basic-subtitle">이런 분과 함께 성장합니다.</h3>
              </li>
              <li className="recruit-growth-list">
                <p className="recruit-growth-img recruit-growth-img1"></p>
                <h3 className="recruit-growth-title">Dream</h3>
                <div className="recruit-growth-cont">
                  <p>전문가로 성장하기 위해</p>
                  <p>노력하는 인재</p>
                </div>
              </li>
              <li className="recruit-growth-list">
                <p className="recruit-growth-img recruit-growth-img2"></p>
                <h3 className="recruit-growth-title">Teamwork</h3>
                <div className="recruit-growth-cont">
                  <p>배려와 존경으로</p>
                  <p>좋은 팀워크를 만드는 인재</p>
                </div>
              </li>
              <li className="recruit-growth-list">
                <p className="recruit-growth-img recruit-growth-img3"></p>
                <h3 className="recruit-growth-title">Ownership</h3>
                <div className="recruit-growth-cont">
                  <p>주인의식을 바탕으로</p>
                  <p>책임감을 가진 인재</p>
                </div>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="basic-title">복지 혜택</h2>
            <ul className="recruit-welfare-item">
              <li className="recruit-welfare-list">
                <p className="recruit-welfare-img recruit-welfare-img1"></p>
                <h3 className="recruit-welfare-title">건강검진</h3>
                <div className="recruit-welfare-cont">
                  <p>직원들의 건강을 위해 2년에 한 번 건강검진 지원</p>
                  <p>(판교메디피움 / 야탑 차병원) 본인+가족 1명</p>
                </div>
              </li>
              <li className="recruit-welfare-list">
                <p className="recruit-welfare-img recruit-welfare-img2"></p>
                <h3 className="recruit-welfare-title">복지 포인트 운영</h3>
                <div className="recruit-welfare-cont">
                  <p>자기 개발, 취미 생활 지원을 위해</p>
                  <p>연간 100만원 지원하고 있습니다.</p>
                </div>
              </li>
              <li className="recruit-welfare-list">
                <p className="recruit-welfare-img recruit-welfare-img3"></p>
                <h3 className="recruit-welfare-title">안식월 제도</h3>
                <div className="recruit-welfare-cont">
                  <p>리프레쉬를 위해 5년 근무한 임직원에게</p>
                  <p>한달 유급 휴가 지급합니다.</p>
                </div>
              </li>

              <li className="recruit-welfare-list">
                <p className="recruit-welfare-img recruit-welfare-img4"></p>
                <h3 className="recruit-welfare-title">상해보험 가입</h3>
                <div className="recruit-welfare-cont">
                  <p>직원들의 건강을 중요하게 생각하기 때문에</p>
                  <p>인당 연간 60만원 상해보험 가입료를 지원합니다</p>
                </div>
              </li>
              <li className="recruit-welfare-list">
                <p className="recruit-welfare-img recruit-welfare-img5"></p>
                <h3 className="recruit-welfare-title">직무발명 제도</h3>
                <div className="recruit-welfare-cont">
                  <p>내부 심사를 통해 특허 출원, 등록비 지원 이외</p>
                  <p>상여금 지급(국내 100만원, 해외 150만원) 합니다.</p>
                </div>
              </li>
              <li className="recruit-welfare-list">
                <p className="recruit-welfare-img recruit-welfare-img6"></p>
                <h3 className="recruit-welfare-title">상여금</h3>
                <div className="recruit-welfare-cont">
                  <p>회사 이익에 따른 상여금을</p>
                  <p>임직원에게 지급합니다.</p>
                </div>
              </li>

              <li className="recruit-welfare-list">
                <p className="recruit-welfare-img recruit-welfare-img7"></p>
                <h3 className="recruit-welfare-title">스톡옵션</h3>
                <div className="recruit-welfare-cont">
                  <p>2년 이상 근속 임직원을 대상으로</p>
                  <p>스톡옵션 제도 시행를 시행합니다.</p>
                </div>
              </li>
              <li className="recruit-welfare-list">
                <p className="recruit-welfare-img recruit-welfare-img8"></p>
                <h3 className="recruit-welfare-title">휴가 제공</h3>
                <div className="recruit-welfare-cont">
                  <p>늦은 시간까지 업무가 이어질 경우 1.5배</p>
                  <p>휴가 제공합니다.</p>
                </div>
              </li>
              <li className="recruit-welfare-list">
                <p className="recruit-welfare-img recruit-welfare-img9"></p>
                <h3 className="recruit-welfare-title">간식</h3>
                <div className="recruit-welfare-cont">
                  <p>업무 및 휴식 시간에 즐길 수 있는</p>
                  <p>각종 과자 및 음료수 등 간식 구비</p>
                </div>
              </li>

              <li className="recruit-welfare-list">
                <p className="recruit-welfare-img recruit-welfare-img10"></p>
                <h3 className="recruit-welfare-title">
                  심야 교통비 및 석식 지원
                </h3>
                <div className="recruit-welfare-cont">
                  <p>늦은 시간까지 업무가 이어질 경우 심야 교통비 및</p>
                  <p>석식을 지원합니다.</p>
                </div>
              </li>
              <li className="recruit-welfare-list">
                <p className="recruit-welfare-img recruit-welfare-img11"></p>
                <h3 className="recruit-welfare-title">경조사 지원</h3>
                <div className="recruit-welfare-cont">
                  <p>경조사 발생시 축하와 조의를 전하고자</p>
                  <p>경조사비 및 화환을 지원합니다.</p>
                </div>
              </li>
              <li className="recruit-welfare-list">
                <p className="recruit-welfare-img recruit-welfare-img12"></p>
                <h3 className="recruit-welfare-title">교육·도서 제공</h3>
                <div className="recruit-welfare-cont">
                  <p>업무의 관련된 교육 및 도서를 지원합니다.</p>
                </div>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="basic-title">전형 절차</h2>
            <div className="recruit-process-box">
              <ul className="recruit-process-item">
                <li className="recruit-process-list">
                  <h3 className="recruit-process-title">
                    <span className="basic-block">01</span>
                    <span className="basic-block">서류 전형</span>
                  </h3>
                </li>
                <li className="recruit-process-list">
                  <h3 className="recruit-process-title">
                    <span className="basic-block">02</span>
                    <span className="basic-block">1차 면접</span>
                  </h3>
                </li>
                <li className="recruit-process-list">
                  <h3 className="recruit-process-title">
                    <span className="basic-block">03</span>
                    <span className="basic-block">임원 면접</span>
                  </h3>
                </li>
                <li className="recruit-process-list">
                  <h3 className="recruit-process-title">
                    <span className="basic-block">04</span>
                    <span className="basic-block">최종 합격</span>
                  </h3>
                </li>
              </ul>
            </div>
          </div>
          </div>
        </>
      ) : (
        <div className="inner">
          <div className="basic-banner recruit-banner">
            <div className="basic-banner-title">
              <p className="txt">배려와 공감속에서</p>
              <p className="txt">창의와 자율을 통해</p>
              <p className="txt">동반 성장하는</p>
              <p className="txt">문화를 가진 기업</p>
            </div>
          </div>

          <div className="recurit-growth">
            <ul className="recruit-growth-item">
              <li className="recruit-growth-list">
                <h2 className="basic-title">헬리오센은</h2>
                <h3 className="basic-subtitle">이런 분과 함께 성장합니다.</h3>
              </li>
              <li className="recruit-growth-list">
                <p className="recruit-growth-img recruit-growth-img1"></p>
                <h3 className="recruit-growth-title">Dream</h3>
                <div className="recruit-growth-cont">
                  <p>전문가로 성장하기 위해 노력하는 인재</p>
                </div>
              </li>
              <li className="recruit-growth-list">
                <p className="recruit-growth-img recruit-growth-img2"></p>
                <h3 className="recruit-growth-title">Teamwork</h3>
                <div className="recruit-growth-cont">
                  <p>배려와 존경으로 좋은 팀워크를 만드는 인재</p>
                </div>
              </li>
              <li className="recruit-growth-list">
                <p className="recruit-growth-img recruit-growth-img3"></p>
                <h3 className="recruit-growth-title">Ownership</h3>
                <div className="recruit-growth-cont">
                  <p>주인의식을 바탕으로 책임감을 가진 인재</p>
                </div>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="basic-title">복지 혜택</h2>
            <ul className="recruit-welfare-item">
              <li className="recruit-welfare-list">
                <p className="recruit-welfare-img recruit-welfare-img1"></p>
                <h3 className="recruit-welfare-title">건강검진</h3>
                <div className="recruit-welfare-cont">
                  <p>직원들의 건강을 위해 2년에 한 번 건강검진 지원</p>
                  <p>(판교메디피움 / 야탑 차병원) 본인+가족 1명</p>
                </div>
              </li>
              <li className="recruit-welfare-list">
                <p className="recruit-welfare-img recruit-welfare-img2"></p>
                <h3 className="recruit-welfare-title">복지 포인트 운영</h3>
                <div className="recruit-welfare-cont">
                  <p>자기 개발, 취미 생활 지원을 위해</p>
                  <p>연간 100만원 지원하고 있습니다.</p>
                </div>
              </li>
              <li className="recruit-welfare-list">
                <p className="recruit-welfare-img recruit-welfare-img3"></p>
                <h3 className="recruit-welfare-title">안식월 제도</h3>
                <div className="recruit-welfare-cont">
                  <p>리프레쉬를 위해 5년 근무한 임직원에게</p>
                  <p>한달 유급 휴가 지급합니다.</p>
                </div>
              </li>

              <li className="recruit-welfare-list">
                <p className="recruit-welfare-img recruit-welfare-img4"></p>
                <h3 className="recruit-welfare-title">상해보험 가입</h3>
                <div className="recruit-welfare-cont">
                  <p>직원들의 건강을 중요하게 생각하기 때문에</p>
                  <p>인당 연간 60만원 상해보험 가입료를 지원합니다</p>
                </div>
              </li>
              <li className="recruit-welfare-list">
                <p className="recruit-welfare-img recruit-welfare-img5"></p>
                <h3 className="recruit-welfare-title">직무발명 제도</h3>
                <div className="recruit-welfare-cont">
                  <p>내부 심사를 통해 특허 출원, 등록비 지원 이외</p>
                  <p>상여금 지급(국내 100만원, 해외 150만원) 합니다.</p>
                </div>
              </li>
              <li className="recruit-welfare-list">
                <p className="recruit-welfare-img recruit-welfare-img6"></p>
                <h3 className="recruit-welfare-title">상여금</h3>
                <div className="recruit-welfare-cont">
                  <p>회사 이익에 따른 상여금을</p>
                  <p>임직원에게 지급합니다.</p>
                </div>
              </li>

              <li className="recruit-welfare-list">
                <p className="recruit-welfare-img recruit-welfare-img7"></p>
                <h3 className="recruit-welfare-title">스톡옵션</h3>
                <div className="recruit-welfare-cont">
                  <p>2년 이상 근속 임직원을 대상으로</p>
                  <p>스톡옵션 제도 시행를 시행합니다.</p>
                </div>
              </li>
              <li className="recruit-welfare-list">
                <p className="recruit-welfare-img recruit-welfare-img8"></p>
                <h3 className="recruit-welfare-title">휴가 제공</h3>
                <div className="recruit-welfare-cont">
                  <p>늦은 시간까지 업무가 이어질 경우 1.5배</p>
                  <p>휴가 제공합니다.</p>
                </div>
              </li>
              <li className="recruit-welfare-list">
                <p className="recruit-welfare-img recruit-welfare-img9"></p>
                <h3 className="recruit-welfare-title">간식</h3>
                <div className="recruit-welfare-cont">
                  <p>업무 및 휴식 시간에 즐길 수 있는</p>
                  <p>각종 과자 및 음료수 등 간식 구비</p>
                </div>
              </li>

              <li className="recruit-welfare-list">
                <p className="recruit-welfare-img recruit-welfare-img10"></p>
                <h3 className="recruit-welfare-title">
                  심야 교통비 및 석식 지원
                </h3>
                <div className="recruit-welfare-cont">
                  <p>늦은 시간까지 업무가 이어질 경우 심야 교통비 및</p>
                  <p>석식을 지원합니다.</p>
                </div>
              </li>
              <li className="recruit-welfare-list">
                <p className="recruit-welfare-img recruit-welfare-img11"></p>
                <h3 className="recruit-welfare-title">경조사 지원</h3>
                <div className="recruit-welfare-cont">
                  <p>경조사 발생시 축하와 조의를 전하고자</p>
                  <p>경조사비 및 화환을 지원합니다.</p>
                </div>
              </li>
              <li className="recruit-welfare-list">
                <p className="recruit-welfare-img recruit-welfare-img12"></p>
                <h3 className="recruit-welfare-title">교육·도서 제공</h3>
                <div className="recruit-welfare-cont">
                  <p>업무의 관련된 교육 및 도서를 지원합니다.</p>
                </div>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="basic-title">전형 절차</h2>
            <div className="recruit-process-box">
              <div className="recruit-process-wrap">
              <ul className="recruit-process-item">
                <li className="recruit-process-list">
                  <h3 className="recruit-process-title">
                    <span className="basic-block">01</span>
                    <span className="basic-block">서류 전형</span>
                  </h3>
                </li>
                <li className="recruit-process-list">
                  <h3 className="recruit-process-title">
                    <span className="basic-block">02</span>
                    <span className="basic-block">1차 면접</span>
                  </h3>
                </li>
                <li className="recruit-process-list">
                  <h3 className="recruit-process-title">
                    <span className="basic-block">03</span>
                    <span className="basic-block">임원 면접</span>
                  </h3>
                </li>
                <li className="recruit-process-list">
                  <h3 className="recruit-process-title">
                    <span className="basic-block">04</span>
                    <span className="basic-block">최종 합격</span>
                  </h3>
                </li>
              </ul>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default RecruitMain;
